module.exports = __webpack_public_path__ + "static/media/zendesk_enable.9ac60f37.png";